import React from "react";
import { FoodsTags } from "@foodpilot/foods";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FoodsIconButton, FoodsTooltip } from "@foodpilot/foods";
import { CommentData } from "./CommentDialog/CommentDialog";
import { SsqPostComment } from "src/api/client-api/post/postSchema";

type AttachmentWrapperProps = {
    children: React.ReactNode;
    ssqPostComments?: SsqPostComment[];
    elementId?: number | null;
    onOpenCommentDialog: (ssqPostElementId: number, commentData: CommentData | null) => void;
};

export const AttachmentWrapper = (props: AttachmentWrapperProps) => {
    const { t } = useTranslation();
    const { children, ssqPostComments, elementId, onOpenCommentDialog } = props;

    const commentsArray = ssqPostComments;
    const ssqPostElementId = elementId ?? null;

    const commentData: CommentData | null =
        Array.isArray(commentsArray) && commentsArray.length > 0 ?
            {
                comment: commentsArray[0].comment,
                commentId: commentsArray[0].id,
                updatedAt: commentsArray[0].updatedAt,
                userName:
                    `${commentsArray[0].createdBy.firstname ?? ""} ${commentsArray[0].createdBy.lastname ?? ""}`.trim(),
            }
        :   null;

    return (
        <Box display="flex" alignItems="center" gap={2} whiteSpace={"nowrap"}>
            {children}
            <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                {commentData && ssqPostElementId && (
                    <Box>
                        <FoodsTags
                            label={t("property.one_note")}
                            variant="tags-white"
                            startIcon="note"
                            onClick={() => onOpenCommentDialog(ssqPostElementId, commentData)}
                        />
                    </Box>
                )}
                {!commentData && ssqPostElementId && (
                    <FoodsTooltip title={t("property.note.add_note")} placement="bottom" width="unset">
                        <Box>
                            <FoodsIconButton
                                size={"xs"}
                                icon="plus"
                                withBackground={true}
                                buttonProps={{
                                    onClick: () => onOpenCommentDialog(ssqPostElementId, commentData),
                                }}
                            />
                        </Box>
                    </FoodsTooltip>
                )}
            </Box>
        </Box>
    );
};
